module.exports = __webpack_public_path__ + "static/media/blog_list3.abb2ebb6.jpg";